import React from 'react';
import { Flex } from '@components/Flex';
import { FaqList } from '@components/FaqList';
import { StyledSection, StyledTextPairing } from './FAQSection.styles';

interface QuestionNodeType
  extends Readonly<{
    section: string;
    question: string;
    answer: string;
  }> {}

interface FAQSectionProps {
  id: string;
  title: string;
  description: string;
  questionNodes: ReadonlyArray<QuestionNodeType>;
}

export const FAQSection: React.FC<FAQSectionProps> = ({ id, title, description, questionNodes }) => {
  return (
    <Flex justifyContent="center" marginTop={[3, 0]}>
      <StyledSection as="section" id={id}>
        <StyledTextPairing
          alignment="left"
          title={title}
          titleTagName="h3"
          titleColor="mono1"
          titleVariant="hed56"
          body={description}
          bodyColor="mono1"
          bodyVariant="featureCopy17"
        />
        <FaqList
          accordion={true}
          questionNodes={questionNodes}
          color="mono1"
          isLinkHidden={true}
          iconColor="mono1"
          titleVariant="featureCopy17"
          variant="secondary"
          sendTelemetry
        />
      </StyledSection>
    </Flex>
  );
};
